var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLevelsProgressStarBlur(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9675 28.5874C25.8617 28.5874 32.2612 22.1879 32.2612 14.2937C32.2612 6.39951 25.8617 0 17.9675 0C10.0733 0 3.67383 6.39951 3.67383 14.2937C3.67383 22.1879 10.0733 28.5874 17.9675 28.5874Z",
    fill: "#D1D5DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38881 22.6559L1.4707 31.1811L7.21086 30.8764L9.81874 36L14.3683 28.1126C11.1085 27.2693 8.30929 25.3063 6.38881 22.6559Z",
    fill: "#D1D5DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5755 22.6134C27.6692 25.2709 24.8699 27.241 21.6172 28.0984L26.181 36L28.7888 30.8764L34.529 31.1811L29.5755 22.6134Z",
    fill: "#D1D5DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9681 24.6544C23.6901 24.6544 28.3287 20.0158 28.3287 14.2937C28.3287 8.57172 23.6901 3.93311 17.9681 3.93311C12.246 3.93311 7.60742 8.57172 7.60742 14.2937C7.60742 20.0158 12.246 24.6544 17.9681 24.6544Z",
    fill: "#D1D5DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0692 13.174C25.3881 12.8622 25.2109 12.3165 24.7716 12.2528L20.6826 11.6575C20.5054 11.6291 20.3566 11.5228 20.2787 11.3598L18.4503 7.65354C18.2519 7.2496 17.6779 7.2496 17.4795 7.65354L15.6582 11.3598C15.5802 11.5157 15.4243 11.6291 15.2543 11.6575L11.1653 12.2528C10.7259 12.3165 10.5487 12.8622 10.8676 13.174L13.8228 16.0583C13.9503 16.1858 14.007 16.363 13.9787 16.5331L13.2842 20.6008C13.2062 21.0402 13.6739 21.3803 14.0708 21.1677L17.7275 19.2472C17.8834 19.1622 18.0747 19.1622 18.2306 19.2472L21.8873 21.1677C22.2842 21.3732 22.7448 21.0402 22.6739 20.6008L21.9724 16.5331C21.944 16.3559 22.0007 16.1787 22.1283 16.0583L25.0692 13.174Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelsProgressStarBlur);
export default __webpack_public_path__ + "static/media/levels-progress-star-blur.7ffb7b47a4de46ec516ab2ee55ec9199.svg";
export { ForwardRef as ReactComponent };